<template>
  <Select v-model="type" :placeholder="placeholder" @on-change="change_value">
    <Option
      v-for="(item, index) in options"
      :value="item.value"
      :key="`${index}-${item.value}`"
    >
      {{ item.label }}
    </Option>
  </Select>
</template>

<script>
import { getParams } from "./utils";
export default {
  props: {
    placeholder: {
      type: String,
      default: "请选择供应商"
    },
    data: {
      type: Array,
      default: () => {}
    },
    param: {
      type: Object,
      default: () => {
        return {
          filter: "supplier",
          op: "="
        };
      }
    }
  },
  data() {
    return {
      type: "",
      options: [{ value: 0, label: "全部供应商" }]
    };
  },
  watch: {
    data(val) {
      val.map(o => this.options.push({ value: o.id, label: o.name }));
    }
  },
  methods: {
    change_value(val) {
      let params = getParams(this.param.filter, val, this.param.op);
      console.log(params);
      this.$emit("get", params, Boolean(val));
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/basic-filter/BaseSupplier.vue